import { connect } from 'react-redux';
import Lesson from './Lesson';
import {
  updateCourseProgress,
  updateLessonProgress,
  updateLessonCompletedProgress,
  updateLessonStandaloneProgress,
  updatePathProgress,
} from '../../../actions/my-progress';
import { updateStreakVideos, shouldQueueStreaksModal } from '../../../actions/streaks';
import SubscriptionCheck from '../../../components/SubscriptionCheck';
import {
  getLessonProgressFromMyProgress,
  getLessonPropswithSlug,
  getNextUrl,
} from './lesson-utils';

import './styles/Lesson.scss';
import { getFlagState } from '../../../lib/feature-flags';
import { pathAnalyticsSelector } from '../../../utils/segment-utils';

const mapState = (state, { match, history }) => {
  const { url, params } = match;
  const { collectionSlug, lessonSlug, courseSlug } = params;
  const { collections, courses, lessons, myPath, myProgress, paths, relatedItems } = state;
  const { collection } = collections;
  const { watching: pathsWatching } = paths;
  const { watching: coursesWatching } = courses;
  const { slugs, watching: lessonsWatching, error } = lessons;
  const { currentCourse } = coursesWatching || {};
  const lessonProps = getLessonPropswithSlug(
    lessonSlug,
    pathsWatching,
    coursesWatching,
    lessonsWatching,
  );
  const nextURL = getNextUrl(url, lessonProps);
  const { currentLesson } = lessonsWatching || pathsWatching || coursesWatching || {};
  const currentLessonProgress = myProgress.lessons[lessonProps.currentLesson?.id];
  let pathLessons = [];
  if (myPath && myPath.flatLessons) {
    pathLessons = myPath.flatLessons;
  }
  const segmentPath = pathAnalyticsSelector({ myProgress, myPath });

  return {
    history,
    ...lessonProps,
    collection,
    currentCourse,
    currentLesson: currentLesson || slugs[lessonSlug] || null,
    currentLessonProgress,
    flags: getFlagState(),
    myPath,
    relatedItems,
    error,
    pathLessons,
    nextURL,
    segmentPath,
    courseSlug,
  };
};

const mapDispatch = {
  updateCourseProgress,
  updateLessonProgress,
  updateLessonCompletedProgress,
  updateLessonStandaloneProgress,
  updatePathProgress,
  updateStreakVideos,
  shouldQueueStreaksModal,
};

export default SubscriptionCheck(connect(mapState, mapDispatch)(Lesson));
